import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "User",
  "use": "User-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" id=\"User\"><path d=\"M10 9.09a4.532 4.532 0 0 0 4.527-4.545A4.532 4.532 0 0 0 10 0a4.547 4.547 0 0 0-4.545 4.545A4.547 4.547 0 0 0 10 9.091zm0 2.637c-3.327 0-10 1.673-10 5v4.091h20v-4.09c0-3.328-6.673-5-10-5z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol